module.exports = __webpack_public_path__ + "4942944301ee80b4fc59f3c66daaf9b3.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/graphics/facilities-map-teal.svg
// module id = 615
// module chunks = 0